import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/footer";
import PageSectionsRenderer from "../../components/common/PageSectionsRenderer";

const Partner = () => {
  return (
    <div className="bg-slate-50 min-h-screen">
      <Navbar />

      {/* Hero Section */}
      <section className="bg-blue-900 text-white py-20 px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4">Partner With Us</h1>
          <p className="text-xl opacity-90">
            Join hands with us to create opportunities and empower Para athletes across Andhra Pradesh.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">Create Lasting Impact</h2>
            <p className="text-slate-600 text-lg leading-relaxed mb-8">
              Your partnership can transform lives and build a stronger Para sports ecosystem in Andhra Pradesh.
              Together, we can create opportunities for athletes with disabilities to excel and inspire others.
            </p>

            <div className="grid md:grid-cols-2 gap-8 mb-8">
              <div>
                <h3 className="text-2xl font-semibold text-slate-900 mb-4">Partnership Opportunities</h3>
                <ul className="space-y-3 text-slate-600">
                  <li className="flex items-start gap-3">
                    <span className="text-blue-600 mt-1">•</span>
                    <span>Title sponsorship for events</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-blue-600 mt-1">•</span>
                    <span>Equipment and training support</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-blue-600 mt-1">•</span>
                    <span>Venue partnerships</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-blue-600 mt-1">•</span>
                    <span>Media and broadcasting rights</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-blue-600 mt-1">•</span>
                    <span>CSR initiatives</span>
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="text-2xl font-semibold text-slate-900 mb-4">Benefits for Partners</h3>
                <ul className="space-y-3 text-slate-600">
                  <li className="flex items-start gap-3">
                    <span className="text-green-600 mt-1">•</span>
                    <span>Brand visibility and recognition</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-green-600 mt-1">•</span>
                    <span>Association with a noble cause</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-green-600 mt-1">•</span>
                    <span>Networking opportunities</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-green-600 mt-1">•</span>
                    <span>Tax benefits under CSR</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-green-600 mt-1">•</span>
                    <span>Positive community impact</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-blue-50 rounded-xl p-6">
              <h3 className="text-2xl font-semibold text-slate-900 mb-4">Get in Touch</h3>
              <p className="text-slate-600 mb-4">
                Interested in partnering with us? We'd love to discuss how we can work together
                to make a difference in the lives of Para athletes.
              </p>
              <div className="text-slate-700">
                <p><strong>Email:</strong> partnerships@parasportsap.org</p>
                <p><strong>Phone:</strong> +91-XXXXXXXXXX</p>
                <p><strong>Contact:</strong> Gonuguntla Koteswara Rao (President)</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <PageSectionsRenderer pageKey="partner" className="pt-0" />

      <Footer />
    </div>
  );
};

export default Partner;
